import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Input,
  Button,
  Spinner,
} from "reactstrap";
import QRCode from "react-qr-code";

import widgetQrCode from "../../../assets/images/icons-component/qrcode.png";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, CodeValue, SetPending, onUpdate, actionEnd, setCanCopy } = props;
  const itemRef = useRef<any>(null);
  const inputRef = useRef<any>(null);
  const [QRcode, setQRcode] = useState<string>(config.data?.codeStr ?? "");
  const [Status, setStatus] = useState<any>("0");

  useEffect(() => {
    if (config.data && config.data?.codeStr) {
      setQRcode(config.data?.codeStr)
      setStatus("1");
      SetPending(false);
    }
  }, [config.data?.codeStr]);

  useEffect(() => {
    if (Status === "2") {
      setTimeout(() => {
        const data = config.data;
        data.codeStr = QRcode;
        onUpdate({ id: config.id, data: { ...data } });
        actionEnd(true);
        CodeValue(QRcode);
        setStatus("1");
        SetPending(false);
      }, 500);
    }
    
  }, [Status]);
  
  const checkValue = () => {
    if (QRcode === "") return;
    SetPending(true);
    setStatus("2");
  };

  return (
    <React.Fragment>
      <div style={{ height: '100%', width: '100%', position: 'absolute' }}>
        {Status === "1" && QRcode !== ""? (
          <div className={`componentCore overflow-hidden ${config.data.titleSwitch? "qrTitle-show" : ""}`} style={{ height: '100%', width: '100%' }} ref={itemRef}>
            {config.data.titleSwitch? (
              <div className="qr-title">
                <span>{config.data.title}</span>
              </div>
            ) : null}
            <QRCode
              className="QRcodeBox"
              value={QRcode}
              size={256}
              level={"L"}
              bgColor={"var(--themeBg)"}
              fgColor={"var(--themeColor)"}
            />
          </div>
        ) : (
          <div className="relative flex h-full flex-col items-center justify-center gap-6 p-6 bg-screen " style={{ cursor: 'auto' }}>
            <div className="widget-head text-area-head">
              <img src={widgetQrCode} alt="" />
            </div>
            <textarea 
              ref={inputRef}
              style={{ resize: "none" }}
              className="ts-text-area h-100 !text-lg"
              onChange={(e) => setQRcode(e.target.value)}
              placeholder="輸入文字 或 網址"
              defaultValue={QRcode}
              data-interaction-target-type="false"
              onFocus={() => {
                setCanCopy(false);
              }}
              onBlur={() => {
                setCanCopy(true);
              }}
            >
            </textarea>
            <Button
              color="primary"
              className={`ts-playBtn btn-load rounded-pill text-sm px-4 h-11 font-semibold ${ QRcode === ""? "ts-disabled" : null }`}
              onClick={checkValue}
              data-interaction-target-type="false"
            >
              <div className="relative justify-center h-100 w-100">
                {Status === "0"? (
                  <span className="fs-16">建立</span>
                ) : Status === "2"? (
                  (
                    <span className="ts-load d-flex justify-center items-center">
                      <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                    </span>
                  )
                ) : null}
              </div>
            </Button>
          </div>
        )}
      </div>
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);